import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Svg } from "assets";
import { ButtonMain } from "components";
import { fundraiserActions, httpRequestsOnSuccessActions } from "store";
import { FindSuccess, useModal } from "utils";
import { PUBLISH_ACTION } from "../constants";
import { fundraiserStatuses } from "../../../fundraisers";

export const PublishModal = ({ id }) => {
  const dispatch = useDispatch();
  const { close } = useModal();
  const success = FindSuccess(PUBLISH_ACTION);

  useEffect(() => {
    if (success) {
      close();
      dispatch(httpRequestsOnSuccessActions.removeSuccess(PUBLISH_ACTION));
    }
  }, [success]);
  const handlePublish = () => {
    dispatch(
      fundraiserActions.changeFundraiserStatus(id, fundraiserStatuses.LIVE)
    );
  };

  return (
    <div className="publish-modal">
      <Svg.PublishAsset />
      <div>
        <p className="publish-modal-title">
          Are you sure you want to Publish fundraiser?
        </p>
        <p className="publish-modal-desc">
          Your fundraiser is ready to go live! Publishing will make it visible
          to donors and allow them to contribute to your cause.
        </p>
      </div>
      <div className="flex-end">
        <button className="publish-modal-no-btn" onClick={close}>
          No
        </button>
        <ButtonMain
          actionTye={PUBLISH_ACTION}
          text="Publish"
          type="button"
          onClick={handlePublish}
        />
      </div>
    </div>
  );
};
